/** Every time the dashboard shows is US Central (Dan's request, 2026-10-01). Data stays UTC;
 *  Intl handles the CDT/CST switch, so the label reads CDT or CST as the date requires. */
const TZ = 'America/Chicago';
const at = new Intl.DateTimeFormat('en-US', { timeZone: TZ, month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
const clock = new Intl.DateTimeFormat('en-US', { timeZone: TZ, hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
const toDate = (t: string | Date) => (typeof t === 'string' ? new Date(t) : t);

/** "Oct 1, 7:42 AM CDT" */
export const central = (t: string | Date) => at.format(toDate(t));
/** "7:42 AM CDT" */
export const centralClock = (t: string | Date) => clock.format(toDate(t));
/** A plan's UTC window ["09:00","11:00"] as Central on `day`: "4:00 AM CDT – 6:00 AM CDT". */
export function centralWindow(windowUtc: [string, string], day: Date = new Date()): string {
  const d = day.toISOString().slice(0, 10);
  return windowUtc.map((hm) => centralClock(`${d}T${hm}:00Z`)).join(' – ');
}
